"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = __importDefault(require("react"));
const Anims_1 = require("./Anims");
const AnimWrap = (props) => {
    const { children, animSpecs } = props;
    const AS = animSpecs;
    const { X360, Y360, fadeInkf, wobY, wobX, fwdx018, fwdx1836, fwdx09, fwdx918, fwdx1827, fwdx2736, fwdy018, fwdy1836, fwdy09, fwdy918, fwdy1827, fwdy2736, floatX, floatShadow, pulseSM, pulseMD, pulseLG, swing, swingDecay, noAnim, } = (0, Anims_1.allAnims)({ degreesHi: AS.degreesHi, degreesLow: AS.degreesLow });
    let theAnim = "noAnim";
    if (AS.name === "X360")
        theAnim = X360;
    else if (AS.name === "Y360")
        theAnim = Y360;
    else if (AS.name === "fadeInkf")
        theAnim = fadeInkf;
    else if (AS.name === "wobX")
        theAnim = wobX;
    else if (AS.name === "wobY")
        theAnim = wobY;
    else if (AS.name === "fwdx018")
        theAnim = fwdx018;
    else if (AS.name === "fwdx1836")
        theAnim = fwdx1836;
    else if (AS.name === "fwdx09")
        theAnim = fwdx09;
    else if (AS.name === "fwdx918")
        theAnim = fwdx918;
    else if (AS.name === "fwdx1827")
        theAnim = fwdx1827;
    else if (AS.name === "fwdx2736")
        theAnim = fwdx2736;
    else if (AS.name === "fwdy018")
        theAnim = fwdy018;
    else if (AS.name === "fwdy1836")
        theAnim = fwdy1836;
    else if (AS.name === "fwdy09")
        theAnim = fwdy09;
    else if (AS.name === "fwdy918")
        theAnim = fwdy918;
    else if (AS.name === "fwdy1827")
        theAnim = fwdy1827;
    else if (AS.name === "fwdy2736")
        theAnim = fwdy2736;
    else if (AS.name === "floatX")
        theAnim = floatX;
    else if (AS.name === "floatShadow")
        theAnim = floatShadow;
    else if (AS.name === "pulseSM")
        theAnim = pulseSM;
    else if (AS.name === "pulseMD")
        theAnim = pulseMD;
    else if (AS.name === "pulseLG")
        theAnim = pulseLG;
    else if (AS.name === "swing")
        theAnim = swing;
    else if (AS.name === "swingDecay")
        theAnim = swingDecay;
    else
        theAnim = noAnim;
    const AnimWrapDiv = styled_components_1.default.div `
    width: 100%;
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    border: ${AS.border};
    -webkit-animation-duration: ${AS.duration}s;
    animation-duration: ${AS.duration}s;
    -webkit-animation-iteration-count: ${AS.iterationCount};
    animation-iteration-count: ${AS.iterationCount};
    -webkit-animation-name: ${theAnim};
    animation-name: ${theAnim};
    -webkit-animation-fill-mode: ${AS.fillMode};
    animation-fill-mode: ${AS.fillMode};
    -webkit-animation-play-state: ${AS.animationPlayState};
    animation-play-state: ${AS.animationPlayState};
    animation-direction: ${AS.direction};
    -webkit-animation-direction: ${AS.direction};
    -webkit-animation-timing-function: ${AS.timing};
    animation-timing-function: ${AS.timing};
    -webkit-animation-delay: ${AS.delay}s;
    animation-delay: ${AS.delay}s;
  `;
    return react_1.default.createElement(AnimWrapDiv, null, children);
};
exports.AnimWrap = AnimWrap;
